import { Box, SxProps } from '@mui/material';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import React from 'react';

type BoxProps = React.ComponentProps<typeof Box> & {
  headline: string;
  subline: string;
};

const styles = {
  box: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: { xs: 5, lg: 6 },
  },
  subline: {
    maxWidth: '60ch',
  },
};

export const EmptyStateBox: React.FC<BoxProps> = ({
  headline,
  subline,
  children,
  sx,
  className = '',
  ...rest
}): React.ReactElement => (
  <Box {...rest} sx={{ ...styles.box, ...sx } as SxProps} className={`empty-state-box ${className}`}>
    <Typography variant="h4" className="headline">
      {headline}
    </Typography>
    <Typography variant="body1" className="subline" sx={styles.subline}>
      {subline}
    </Typography>
    {children}
  </Box>
);

EmptyStateBox.displayName = 'EmptyStateBox';
